module.exports = "https://web-assets.ifttt.com/packs/media/docs/branding_explore-be5ca7f0.gif";